import {
  TabView as BaseTabView,
  TabDefinition,
} from '@features/campaigns/components/TabView';
import { SalesMetrics } from './SalesMetrics';
import { PurchaseMetrics } from './PurchaseMetrics';
import { useFeatures } from '@utils/hooks';
import { CpgReport } from '../../api/schema';

type SummaryTabsProps = {
  allReports: CpgReport[];
  enableSalesRate: boolean;
};

export const SummaryTabs = ({
  allReports,
  enableSalesRate,
}: SummaryTabsProps) => {
  const features = useFeatures();

  const tabs: TabDefinition[] = [
    {
      label: 'Sales Metrics',
      component: (
        <SalesMetrics
          allReports={allReports}
          enableSalesRate={enableSalesRate}
        />
      ),
      path: 'sales-metrics',
    },
    ...(features.cpgAdditionalMetrics
      ? [
          {
            label: 'Purchase Metrics',
            component: <PurchaseMetrics allReports={allReports} />,
            path: 'purchase-metrics',
          },
        ]
      : []),
  ];

  return (
    <BaseTabView tabs={tabs} backgroundColor="white" borderBottom={false} />
  );
};
